// App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

// Layout Components
import Header from './Components/Header';

// Menus
import { conferenceMenu } from "./Components/menus";
import Committees from './Components/conferencePages/Committees'
import CallForPaper from './Components/conferencePages/CallForPaper'
import ImportantDates from './Components/conferencePages/ImportantDates'
import Submission from './Components/conferencePages/Submission'
import Registration from './Components/conferencePages/Registration'
import Contact from './Components/conferencePages/Contact'
import Downloads from './Components/conferencePages/Downloads'

// Pages
import Landingpage from './Components/conferencePages/Home';

// Dynamic Pages
import Page404 from "./Components/404-page/Page404";
import ScrollToTop from "./Components/ScrollToTop";

import usePageTracking from "./usePageTracking";

import ReactGA from "react-ga4";
ReactGA.initialize("G-GXFJV8V1ZQ");
ReactGA.send("pageview");



function AppRoutes() {
  usePageTracking();
  return (
    <>
      <Header menus={conferenceMenu} />

      <Routes>
        <Route path="/" element={<Landingpage />} />
        <Route path="/landingpage/committees" element={<Committees />} />
        <Route path="/landingpage/call-for-paper" element={<CallForPaper />} />
        <Route path="/landingpage/important-dates" element={<ImportantDates />} />
        <Route path="/landingpage/submission" element={<Submission />} />
        <Route path="/landingpage/registration" element={<Registration />} />
        <Route path="/landingpage/contact" element={<Contact />} />
        <Route path="/landingpage/downloads" element={<Downloads />} /> 

        <Route path="*" element={<Page404/>} />
      </Routes>
      

    </>
  );
}

export default function App() {
  
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}
